/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const GetPortfoplusPage = lazyLoad(
  () => import('./index'),
  module => module.GetPortfoplusPage,
);
